import Vuex from "vuex";
import Vue from "vue";

import { inscriptionFlowFileModule } from "./modules/InscriptionFlowFileModule";
import { inscriptionFlowLegalPersonFileModule } from "./modules/InscriptionFlowLegalPersonFileModule";
import { RootState } from "./RootState";
import { autonomousFormTypeModule } from "./modules/AutonomousFormTypeModule";
import { autonomousFormCheckboxFormTypeModule } from "./modules/AutonomousFormCheckboxFormTypeModule";
import { autonomousFormBaseFieldModule } from "./modules/AutonomousFormBaseFieldModule";
import { autonomousFormLegalPersonBaseFieldModule } from "./modules/AutonomousFormLegalPersonBaseFieldModule";
import { autonomousFormBaseCheckboxModule } from "./modules/AutonomousFormBaseCheckboxModule";
import { autonomousFormLegalPersonBaseCheckboxModule } from "./modules/AutonomousFormLegalPersonBaseCheckboxModule";
import { autonomousFormAdditionalFieldModule } from "./modules/AutonomousFormAdditionalFieldModule";
import { autonomousFormAdditionalCheckboxModule } from "./modules/AutonomousFormAdditionalCheckboxModule";
import { autonomousFormAttachmentFieldModule } from "./modules/AutonomousFormAttachmentFieldModule";
import { autonomousFormAttachmentFieldFormTypeModule } from "./modules/AutonomousFormAttachmentFieldFormTypeModule";

Vue.use(Vuex);

import { config } from "vuex-module-decorators";
// Set rawError to true by default on all @Action decorators
config.rawError = true;

// Magasin VueX qui coordonne l'échange d'infos entre les différentes vues.
export const store = new Vuex.Store<RootState>({
  // Données partagées du magasin (ne peuvent pas être modifiées directement)
  modules: {
    flowFiles: inscriptionFlowFileModule,
    flowLegalPersonFiles: inscriptionFlowLegalPersonFileModule,
    formTypes: autonomousFormTypeModule,
    formCheckboxFormType: autonomousFormCheckboxFormTypeModule,
    formBaseFields: autonomousFormBaseFieldModule,
    formLegalPersonBaseFields: autonomousFormLegalPersonBaseFieldModule,
    formBaseCheckbox: autonomousFormBaseCheckboxModule,
    formLegalPersonBaseCheckbox: autonomousFormLegalPersonBaseCheckboxModule,
    formAdditionalFields: autonomousFormAdditionalFieldModule,
    formAdditionalCheckboxes: autonomousFormAdditionalCheckboxModule,
    formAttachmentFields: autonomousFormAttachmentFieldModule,
    formAttachmentFieldFormType: autonomousFormAttachmentFieldFormTypeModule
  },
  state: {},

  // Accesseurs pour propriétés calculées
  getters: {},

  // Opérations de modification des données
  mutations: {},

  // Actions pouvant être appelées par les vues pour agir sur le magasin
  actions: {}
});
